import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FarmApiService } from 'src/app/core/api/farm-api.service';
import { UserData } from 'src/app/core/models/classes/user-data';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { IBaseAlertModel } from 'src/app/core/models/interfaces/modal-components-models';
import { AccountService } from 'src/app/core/services/account.service';
import { ClientAlertService } from 'src/app/core/services/client-alert.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
  user: UserData;
  version: any = "";
  constructor(
    private storageService: StorageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private alertService: ClientAlertService,
    private translateService: TranslateService,
    private accountService: AccountService,
    private farmService: FarmApiService,
    private loadingService: LoadingService) {
    // if (Capacitor.getPlatform() != "web") {
    //   App.getInfo().then(e => {
    //     this.version = e.version;
    //   });
    // }
  }

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.storageService.get(StorageKeys.USER).then(user => {
      if (user.IsSuccess) {
        this.user = user.Data;
      }
    });
  }

  navigate(type) {
    let url = this.router.url + "/" + type;
    this.router.navigate([url]);
  }

  deleteAccount() {
    this.alertService.confirmAlertController(this.translateService.instant("profile.delete-account-alert")).then(() => {
      this.alertService.alert.onDidDismiss().then(res => {
        if (res.data == true) {
          this.loadingService.showLoading();
          this.accountService.deleteAccount().subscribe(res => {
            if (res) {
              this.loadingService.hideLoading();
            }
          })
        }
      });
    });
  }

  logOut() {
    let scope = this
    let opts: IBaseAlertModel = {
      buttons: [{
        callback: () => {
          scope.accountService.Logout()
          scope.farmService.farmList = null;
        },
        color: "primary",
        fill: "solid",
        text: this.translateService.instant("profile.logout_alert_btn_confirm")
      },
      {
        callback: () => { },
        color: "dark",
        fill: "clear",
        text: this.translateService.instant("profile.logout_alert_btn_cancel")
      }
      ],
      title: this.translateService.instant("profile.logout_alert_title"),
    }
    this.alertService.confirmAlert(opts).then(res => { })
  }


}
